import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import NewCommonServiceContent from "../../../common/NewCommonServices/NewCommonServiceContent";
import websiteContent1 from "../../../../assets/images/serviceImages/websiteContent1.webp";
import websiteContent2 from "../../../../assets/images/serviceImages/websiteContent2.webp";
import websiteContent3 from "../../../../assets/images/serviceImages/websiteContent3.webp";

const WebsiteContentWork = () => {
  return (
    <div>
      <NewCommonServiceContent>
        <div>
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            className="flex justify-center items-center"
            pagination={{
              type: "bullets",
              el: ".pagination-progress",
              clickable: true,
            }}
            autoplay={true}
            spaceBetween={20}
            slidesPerView={1}
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
            loop
          >
            <SwiperSlide>
              <img
                src={websiteContent1}
                className="rounded-[16px] w-full"
                alt=""
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src={websiteContent2}
                className="rounded-[16px] w-full"
                alt=""
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src={websiteContent3}
                className="rounded-[16px] w-full"
                alt=""
              />
            </SwiperSlide>
          </Swiper>
          <div className="swiper-pagination pagination-progress w-full relative z-10 py-5"></div>
        </div>
      </NewCommonServiceContent>
    </div>
  );
};

export default WebsiteContentWork;
